import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Requisito } from '../models/requisito.model';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})
export class RequisitoService extends BaseService<Requisito> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/requisito`, injector);
  }

  getByEstimativaId(id: number): Observable<any> {
    return this.http.get<Page<Requisito>>(`${environment.API_PRICE}/requisito/GetByEstimativaId/${id}`);
  }
}
